import { render, staticRenderFns } from "./searchProv.vue?vue&type=template&id=10ef8b4f&scoped=true"
import script from "./searchProv.vue?vue&type=script&lang=js"
export * from "./searchProv.vue?vue&type=script&lang=js"
import style0 from "./searchProv.vue?vue&type=style&index=0&id=10ef8b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef8b4f",
  null
  
)

export default component.exports